import DebugUANC from '../core/version/debug';

export const loadPREBIDScript = async (windowToLoadScript: Window = window): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        if (windowToLoadScript.pbjs && typeof windowToLoadScript.pbjs.processQueue === 'function' && windowToLoadScript.pbjs.que)
            return resolve();
        const { detection, event, UANC } = window.Inpl.Ad;

        const pbjsScript = windowToLoadScript.document.createElement('script');
        pbjsScript.async = true;
        pbjsScript.type = 'text/javascript';
        pbjsScript.src = `${detection!.protocol}//${detection!.libraryPath}${'prebid_external_script'}.js`;

        const comment = windowToLoadScript.document.createComment('Prebid: pbjs');
        const headTag = windowToLoadScript.document.getElementsByTagName('head')[0];
        headTag.appendChild(comment);
        headTag.appendChild(pbjsScript);

        event?.subscribe('load', pbjsScript, () => {
            UANC instanceof DebugUANC && UANC.info('Prebid script loaded successfully');
            return resolve();
        });

        event?.subscribe('error', pbjsScript, () => {
            return reject(new Error('Error loading Prebid script'));
        });
        event?.subscribe('abort', pbjsScript, () => {
            return reject(new Error('Prebid script loading aborted'));
        });
    });
};
